module.exports = __webpack_public_path__ + "img/Chart.04eaac6a.svg";